import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function Notifications() {
  const [message, setMessage] = useState('');
  const [audience, setAudience] = useState('All Users');
  const [scheduled, setScheduled] = useState('');
  const [sent, setSent] = useState([]);

  function handleSend(e) {
    e.preventDefault();
    if (!message.trim()) return;
    const entry = { id: Date.now(), message, audience, scheduled: scheduled || 'Now', status: 'Queued' };
    setSent(prev => [entry, ...prev]);
    setMessage('');
    setScheduled('');
  }

  return (
    <>
      <Helmet><title>Push Notifications | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Push Notifications</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Promotions</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="card card-default">
                <div className="card-header"><h2>Create Notification</h2></div>
                <div className="card-body">
                  <form onSubmit={handleSend}>
                    <div className="mb-3"><label className="form-label">Message</label><textarea className="form-control" rows={4} value={message} onChange={(e)=>setMessage(e.target.value)} placeholder="Enter notification message" /></div>
                    <div className="mb-3"><label className="form-label">Audience</label><select className="form-select" value={audience} onChange={(e)=>setAudience(e.target.value)}><option>All Users</option><option>Customers</option><option>Sellers</option><option>Subscribers</option></select></div>
                    <div className="mb-3"><label className="form-label">Schedule</label><input type="datetime-local" className="form-control" value={scheduled} onChange={(e)=>setScheduled(e.target.value)} /></div>
                    <div className="d-flex gap-2"><button type="submit" className="btn btn-primary">Send</button><button type="button" className="btn btn-secondary" onClick={()=>{setMessage(''); setScheduled('');}}>Clear</button></div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card card-default">
                <div className="card-header"><h2>Recent Notifications</h2></div>
                <div className="card-body">
                  {sent.length === 0 ? <p>No notifications yet.</p> : (
                    <ul className="list-group">
                      {sent.map(n => (
                        <li key={n.id} className="list-group-item d-flex justify-content-between align-items-start">
                          <div className="ms-2 me-auto">
                            <div className="fw-bold">{n.audience} • {n.scheduled}</div>
                            {n.message}
                          </div>
                          <span className="badge bg-primary rounded-pill">{n.status}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notifications;
